<template>
<section class="form-wrap view-wrap three-quarters">
	<Heading :level="1" text="Thank you for submitting your stage 2 application" />

	<p>Your application has been submitted for review. We will contact you soon.</p>
	<p>You can see the current status of your application on your <router-link :to="{name: 'Dashboard'}">dashboard</router-link></p>
</section>
</template>

<script>

export default {
	name: 'ApplicationConfirmation'
};
</script>
